const lodash = require('lodash');
const seedrandom = require('seedrandom');

const init = ({ x }) => {
  const { seed } = x;
  seedrandom(seed, { global: true });
  const _ = lodash.runInContext();

  const intInclusive = (min, max) => {
    return Math.floor(x.random() * (max - min + 1)) + min;
  };

  const evenIntInclusive = (min, max) => {
    let num;
    do {
      num = intInclusive(min, max);
    } while (num % 2 !== 0);
    return num;
  };

  const oddIntInclusive = (min, max) => {
    let num;
    do {
      num = intInclusive(min, max);
    } while (num % 2 === 0);
    return num;
  };

  const decimalInclusive = (min, max) => {
    return intInclusive(min * 100, max * 100) / 100;
  };

  const sample = (...args) => {
    return _.sample.apply(this, args);
  };

  const sampleSize = (...args) => {
    return _.sampleSize.apply(this, args);
  };

  const sign = () => {
    return _.sample([-1, 1]);
  };

  const shuffle = (...args) => {
    return _.shuffle.apply(this, args);
  };

  return {
    di: decimalInclusive,
    decimalInclusive,
    ii: intInclusive,
    intInclusive,
    evenIntInclusive,
    oddIntInclusive,
    sample,
    sampleSize,
    shuffle,
    sign,
  };
};

module.exports = init;
